import { Stack } from "@mui/material";
import MzButton from "@markaaz/ui/MzButton";
import MzAlert from "@markaaz/ui/MzAlert";
import Section from "components/common/Section";
import DetailsRow from "./DetailsRow";

export default function MarkaazHosted({
  pageData,
  markaazHostedData,
  markaazHostedAlert,
  fileInputRef,
  showUploadButton,
  loading,
  disableUploadButton,
  onUpload,
  onFileInput,
  onSaveMarkaazHosted,
  onFileRemove,
  onAlertClose
}) {
  const { connectionData, keyData } = pageData;
  // const fileName = markaazHostedData?.keys[0]?.publicKey !== "";

  return (
    <>
      <Section pageData={connectionData}>
        {connectionData.items.map((item, index) => {
          const inputName = item.inputName;
          const rowData = markaazHostedData?.connection?.[inputName] || "";
          return (
            <DetailsRow
              isConnection={true}
              label={item.label}
              rowData={rowData}
              inputName={inputName}
              showCopyButton={true}
            />
          );
        })}
      </Section>
      <Section pageData={keyData}>
        {keyData.items.map((item, index) => (
          <DetailsRow
            isKeys={true}
            isMarkaazHosted={true}
            label={item.label}
            disableUploadButton={disableUploadButton}
            showUploadButton={showUploadButton}
            onFileInput={onFileInput}
            fileInputRef={fileInputRef}
            onFileRemove={onFileRemove}
            onUpload={onUpload}
          />
        ))}
      </Section>
      <Stack direction="row" gap={10} alignItems="center">
        <MzButton
          variant="contained"
          size="large"
          onClick={onSaveMarkaazHosted}
          loading={loading}
          disabled={disableUploadButton}
        >
          Save
        </MzButton>
        {markaazHostedAlert.message && (
          <MzAlert
            sx={{ alignItems: "center" }}
            severity={markaazHostedAlert.type === "success" ? "success" : "error"}
            onClose={() => {
              onAlertClose("mhs");
            }}
          >
            {markaazHostedAlert.message}
          </MzAlert>
        )}
      </Stack>
    </>
  );
}
